import {useCallback} from 'react';
import {useBusinessCardAnalyticsMutation} from 'api/services/leads';
import {useSearchBaseParams} from 'utils/searchParamsContext';

function useBusinessCardsAnalytics() {
    const [, mutateAnalytics] = useBusinessCardAnalyticsMutation();
    const {formDataHash} = useSearchBaseParams();

    const clickToCallAnalyticEvent = useCallback(() => {
        mutateAnalytics(JSON.stringify({}), new URLSearchParams({
            contact_type: 'phone',
            lead_form_data: formDataHash || '',
        }));
    }, [mutateAnalytics, formDataHash]);

    const clickToExternalLinkAnalyticEvent = useCallback((link_type?: string) => {
        if (!link_type) return;
        mutateAnalytics(JSON.stringify({}), new URLSearchParams({
            contact_type: link_type,
            lead_form_data: formDataHash || '',
        }));
    }, [mutateAnalytics, formDataHash]);

    return {
        clickToCallAnalyticEvent,
        clickToExternalLinkAnalyticEvent,
        mutateAnalytics,
    };
}

export default useBusinessCardsAnalytics;
